(function () {
  'use strict';

  var ranges = [
    { size: 14, min: 23.0, max: 26.9 },
    { size: 15, min: 27.0, max: 28.9 },
    { size: 16, min: 29.0, max: 30.9 },
    { size: 17, min: 31.0, max: 32.6 },
    { size: 18, min: 32.7, max: 33.9 },
    { size: 19, min: 34.0, max: 36.0 },
    { size: 20, min: 36.1, max: 38.5 },
    { size: 21, min: 38.6, max: 40.6 }
  ];

  function recommendSize(diameter) {
    var roundedDiameter = Math.round(diameter * 10) / 10;
    if (roundedDiameter < 23 || roundedDiameter > 40.6) return null;

    for (var i = 0; i < ranges.length; i += 1) {
      if (roundedDiameter >= ranges[i].min && roundedDiameter <= ranges[i].max) {
        return ranges[i];
      }
    }

    return null;
  }

  function normalizeSizeValue(value) {
    var match = String(value || '').match(/(?:^|\D)(14|15|16|17|18|19|20|21)(?:\D|$)/);
    return match ? parseInt(match[1], 10) : null;
  }

  function readNumber(input) {
    var raw = String(input.value || '').replace(',', '.').trim();
    return raw === '' ? NaN : Number(raw);
  }

  function createChangeEvent() {
    if (typeof Event === 'function') return new Event('change', { bubbles: true });

    var event = document.createEvent('Event');
    event.initEvent('change', true, true);
    return event;
  }

  function selectProductSize(calculator, size) {
    var form = calculator.closest ? calculator.closest('form') : null;

    if (!form) {
      var parent = calculator.parentNode;
      while (parent && parent !== document) {
        if (parent.tagName === 'FORM') {
          form = parent;
          break;
        }
        parent = parent.parentNode;
      }
    }

    if (!form) return false;

    var position = calculator.getAttribute('data-size-option-position');
    if (!position || position === '0') return false;

    var selectors = form.querySelectorAll('.product-form__single-selector[data-option-position="' + position + '"]');

    for (var i = 0; i < selectors.length; i += 1) {
      var selector = selectors[i];

      if (selector.tagName === 'SELECT') {
        for (var j = 0; j < selector.options.length; j += 1) {
          if (normalizeSizeValue(selector.options[j].value) === size) {
            selector.value = selector.options[j].value;
            selector.dispatchEvent(createChangeEvent());
            if (selector.scrollIntoView) selector.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return true;
          }
        }
      } else if (normalizeSizeValue(selector.value) === size) {
        selector.checked = true;
        selector.dispatchEvent(createChangeEvent());
        if (selector.scrollIntoView) selector.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return true;
      }
    }

    return false;
  }

  function initCalculator(calculator) {
    if (!calculator || calculator.getAttribute('data-initialized') === 'true') return;

    var widthInput = calculator.querySelector('[data-tire-width]');
    var ratioInput = calculator.querySelector('[data-aspect-ratio]');
    var rimInput = calculator.querySelector('[data-rim-size]');
    var calculateButton = calculator.querySelector('[data-calculate-tire-size]');
    var primaryLabel = calculator.querySelector('[data-primary-label]');
    var primaryUnit = calculator.querySelector('[data-primary-unit]');
    var secondaryLabel = calculator.querySelector('[data-secondary-label]');
    var secondaryUnit = calculator.querySelector('[data-secondary-unit]');
    var message = calculator.querySelector('[data-tire-message]');
    var result = calculator.querySelector('[data-tire-result]');
    var summaryOutput = calculator.querySelector('[data-tire-summary]');
    var fitNote = calculator.querySelector('[data-fit-note]');
    var selectButton = calculator.querySelector('[data-select-cover-size]');

    if (!widthInput || !ratioInput || !rimInput || !calculateButton || !message || !result || !summaryOutput || !fitNote) return;

    calculator.setAttribute('data-initialized', 'true');
    var recommendedSize = null;

    function showMessage(text, isError) {
      message.textContent = text || '';
      if (isError) message.classList.add('tire-calculator__message--error');
      else message.classList.remove('tire-calculator__message--error');
    }

    function hideResult() {
      showMessage('', false);
      result.hidden = true;
      result.style.display = 'none';
      if (selectButton) {
        selectButton.hidden = true;
        selectButton.classList.remove('is-selected');
        selectButton.setAttribute('aria-pressed', 'false');
      }
    }

    function isFlotationSize(firstValue) {
      return isFinite(firstValue) && firstValue > 0 && firstValue < 100;
    }

    function updateFormatUI() {
      var flotation = isFlotationSize(readNumber(widthInput));

      if (primaryLabel) primaryLabel.textContent = flotation ? 'Tire diameter' : 'Tire width';
      if (primaryUnit) primaryUnit.textContent = flotation ? 'inch' : 'mm';
      if (secondaryLabel) secondaryLabel.textContent = flotation ? 'Tire width' : 'Aspect ratio';
      if (secondaryUnit) secondaryUnit.textContent = flotation ? 'inch' : '%';

      widthInput.setAttribute('aria-label', flotation ? 'Overall tire diameter in inches' : 'Tire width in millimeters');
      ratioInput.setAttribute('aria-label', flotation ? 'Tire width in inches' : 'Aspect ratio percentage');
    }

    function calculate() {
      var firstValue = readNumber(widthInput);
      var secondValue = readNumber(ratioInput);
      var rim = readNumber(rimInput);
      var flotation = isFlotationSize(firstValue);
      var diameter;
      var enteredSize;

      hideResult();

      if (flotation) {
        if (!isFinite(secondValue) || !isFinite(rim) || firstValue < 20 || firstValue > 60 || secondValue < 4 || secondValue > 25 || rim < 8 || rim > 30 || firstValue <= rim) {
          showMessage('Please enter a valid flotation size, for example 39 / 13.5 R15.', true);
          return;
        }

        diameter = firstValue;
        enteredSize = firstValue + ' × ' + secondValue + ' R' + rim;
      } else {
        if (!isFinite(firstValue) || !isFinite(secondValue) || !isFinite(rim) || firstValue < 100 || firstValue > 500 || secondValue < 20 || secondValue > 100 || rim < 8 || rim > 30) {
          showMessage('Please enter a valid metric size, for example 255 / 70 R18.', true);
          return;
        }

        diameter = rim + (2 * (firstValue * (secondValue / 100) / 25.4));
        enteredSize = firstValue + ' / ' + secondValue + ' R' + rim;
      }

      var recommendation = recommendSize(diameter);
      result.hidden = false;
      result.style.display = 'block';

      if (!recommendation) {
        recommendedSize = null;

        if (diameter > 40.6) {
          summaryOutput.textContent = enteredSize + ' has a ' + diameter.toFixed(2) + '-inch diameter → tire cover size is larger than 21 inch';
        } else {
          summaryOutput.textContent = enteredSize + ' has a ' + diameter.toFixed(2) + '-inch diameter → please contact us';
        }

        fitNote.innerHTML = '<strong>Notes:</strong> Please measure your spare tire and email us your request.';
        return;
      }

      recommendedSize = recommendation.size;
      summaryOutput.textContent = enteredSize + ' has a ' + diameter.toFixed(2) + '-inch diameter → tire cover size is ' + recommendation.size + ' inch';
      fitNote.innerHTML = '<strong>Notes:</strong> Always measure the full outside diameter of your spare tire before ordering. Tire dimensions can vary slightly by manufacturer and tread.';

      if (selectButton) {
        selectButton.textContent = 'Select ' + recommendation.size + ' inch';
        selectButton.classList.remove('is-selected');
        selectButton.setAttribute('aria-pressed', 'false');
        selectButton.hidden = false;
      }
    }

    calculateButton.onclick = calculate;

    var inputs = [widthInput, ratioInput, rimInput];
    for (var i = 0; i < inputs.length; i += 1) {
      inputs[i].oninput = function () {
        hideResult();
        updateFormatUI();
      };

      inputs[i].onkeydown = function (event) {
        event = event || window.event;
        if (event.key === 'Enter' || event.keyCode === 13) {
          if (event.preventDefault) event.preventDefault();
          calculate();
          return false;
        }
      };
    }

    updateFormatUI();

    if (selectButton) {
      selectButton.onclick = function () {
        if (!recommendedSize) return;

        if (selectProductSize(calculator, recommendedSize)) {
          selectButton.classList.add('is-selected');
          selectButton.setAttribute('aria-pressed', 'true');
          selectButton.textContent = recommendedSize + ' inch selected';
          showMessage(recommendedSize + ' inch selected.', false);
        } else {
          selectButton.classList.remove('is-selected');
          selectButton.setAttribute('aria-pressed', 'false');
          showMessage('Choose ' + recommendedSize + ' inch from the size options above.', true);
        }
      };
    }
  }

  function initAll() {
    var calculators = document.querySelectorAll('[data-tire-calculator]');
    for (var i = 0; i < calculators.length; i += 1) initCalculator(calculators[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);
  setTimeout(initAll, 500);
  setTimeout(initAll, 1500);
}());
